export default "__VITE_ASSET__BcEH_n8H__"